var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ag-overlay-loading-center",
      staticStyle: {
        position: "relative",
        "background-color": "transparent",
        border: "none",
        height: "100%",
        "text-align": "center"
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            position: "absolute",
            top: "50%",
            left: "0",
            right: "0",
            transform: "translateY(-50%)",
            height: "10%",
            "max-height": "200px"
          }
        },
        [
          _c("i", { staticStyle: { "font-style": "normal" } }, [
            _vm._v(_vm._s(_vm._i18nGridLocalText("noRowsToShow")))
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }